export default __webpack_public_path__ + "static/portfolio_gallery_5-54011b089de4f0b951214890d402fa66.jpg";